import {ReactNode} from 'react';
import {Collapse} from 'antd';
import {t} from 'i18next';
import styles from './index.module.scss';

export interface ILogsWrapperProps {
  isOpen?: boolean;
  onOpen?: () => void;
  children: ReactNode | ReactNode[];
  title?: string;
}

const LogsWrapper = ({
                       isOpen,
                       onOpen,
                       children,
                       title = t('logs'),
                     }: ILogsWrapperProps) => {
  const handleCollapseOpen = (keys: string | string[]) => {
    if (keys.includes('1')) {
      onOpen?.();
    }
  };
  return (
    <section className={styles.logsWrapper}>
      <Collapse
        onChange={handleCollapseOpen}
        defaultActiveKey={isOpen ? '1' : undefined}
      >
        <Collapse.Panel header={title} key='1'>
          {children}
        </Collapse.Panel>
      </Collapse>
    </section>
  );
};
export default LogsWrapper;
